<span
    class="overflow-text__value"
    #textEl
    [class.overflow-text__value--clamp]="lines > 1"
    [style.-webkit-line-clamp]="lines > 1 ? lines : null">
    {{ value }}
</span>
@if (isOverflowing) {
    <button
        class="overflow-text__action"
        type="button"
        #actionBtn
        kendoTooltip
        #tooltipRef="kendoTooltip"
        showOn="none"
        position="top"
        tooltipClass="overflow-text-tooltip"
        [tooltipTemplate]="tooltipTpl"
        [attr.aria-label]="actionAriaLabel | translate"
        (click)="onActionClick($event, tooltipRef)"
        (mouseenter)="onEnter(tooltipRef)"
        (mouseleave)="onLeave(tooltipRef)"
        (focus)="onFocus(tooltipRef)"
        (blur)="onBlur(tooltipRef)">
        @if (isCopied) {
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
        }
        @if (!isCopied && showCopyIcon) {
            <fa-icon [icon]="['fas', 'copy']"></fa-icon>
        }
        @if (!isCopied && !showCopyIcon) {
            <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        }
        @if (isCopied) {
            <span class="overflow-text__copied-label">{{ 'Copied' | translate }}</span>
        }
    </button>
}
<ng-template #tooltipTpl>{{ value }}</ng-template>
